import { render } from "./ModalAnnouncement.vue?vue&type=template&id=74608962&scoped=true"
import script from "./ModalAnnouncement.vue?vue&type=script&lang=js"
export * from "./ModalAnnouncement.vue?vue&type=script&lang=js"

import "./ModalAnnouncement.vue?vue&type=style&index=0&id=74608962&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74608962"]])

export default __exports__